import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Toast, ToastContainer } from '@salesforce/design-system-react';

export class SetupToast extends Component {
  handleRequestClose() {
    this.props.actions.dismissToast();
  }

  render() {
    const { enabled, contentKey, variant } = this.props.toast;
    const { formatMessage } = this.props.intl;
    const heading = formatMessage({ id: `SetupToast.${contentKey}.heading` });
    const details = formatMessage({
      id: `SetupToast.${contentKey}.details`,
      defaultMessage: ''
    });
    return (
      <ToastContainer>
        {enabled ? (
          <Toast
            labels={{
              heading: heading,
              details: details || null
            }}
            variant={variant}
            onRequestClose={() => this.handleRequestClose()}
          />
        ) : null}
      </ToastContainer>
    );
  }
}

SetupToast.propTypes = {
  toast: PropTypes.exact({
    enabled: PropTypes.bool.isRequired,
    contentKey: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired
  }),
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(SetupToast);
